
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { defineComponent, reactive } from 'vue'
import ContentAdaptLayout from '../../../../_components/content-adapt-layout/content-adapt-layout.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import { TerminalOrderTaskDetailService, QueryParams, ResponseData, STATUS } from './message-push.service'

export default defineComponent({
  components: {
    ContentAdaptLayout,
    IPColumn
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const injector = useReflectiveInjector([TerminalOrderTaskDetailService])
    const service = injector.get(TerminalOrderTaskDetailService)

    const tabState = reactive({
      active: STATUS.DONE.toString(),
      loading: false
    })

    const queryParams = reactive<QueryParams>({
      task_id: props.id as string,
      page: 1,
      limit: 10,
      status: STATUS.DONE
    })
    const viewModel = reactive({
      data: {} as ResponseData
    })

    function getData (isOperatePage:boolean = false) {
      !isOperatePage && (queryParams.page = 1)
      service.getTerminalOrderTaskDetail(queryParams).then(response => {
        viewModel.data = response
      })
    }

    getData()

    return {
      STATUS,
      tabState,
      queryParams,
      viewModel,
      handleTabSwitch (tab: any) {
        queryParams.status = Number(tab.index)
        getData()
      },
      handlerChangeSizeChange (size: number) {
        queryParams.limit = size
        getData()
      },
      handlerChangeCurrentChange (page: number) {
        queryParams.page = page
        getData(true)
      },
    }
  }
})
